import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import * as moment from 'moment';
import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { apiInterceptor } from './core/http/api.interceptor';
import { KeycloakAngularModule } from 'keycloak-angular';
import { NonDeprecatedKeycloakService as KeycloakService } from '@core/keycloak/non-deprecated-keycloak.service';
import { environment } from '@env/environment';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';


moment.locale('de');
registerLocaleData(localeDe);

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY : HH:mm'
  },
  display: {
    dateInput: 'DD.MM.YYYY : HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(KeycloakAngularModule),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiInterceptor])),
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: (kc: KeycloakService) => {
        return () => kc.init({
          config: {
            url: environment.keycloak.URL,
            realm: environment.keycloak.REALM,
            clientId: environment.keycloak.CLIENT_ID,
            },
            initOptions: {
              onLoad: 'login-required',
              checkLoginIframe: false
            },
            // Disable the built-in Keycloak bearer interceptor because we
            // implement our own in api.interceptor.ts.  Leaving this set to
            // true would have no effect in Angular 17+ without additionally
            // providing the KeycloakBearerInterceptor via DI, but disabling
            // it clarifies our intent.
            enableBearerInterceptor: false,
            loadUserProfileAtStartUp: true,
            bearerExcludedUrls: ['/assets']
        });
      },
      deps: [KeycloakService],
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false, strict: true } },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ]
};
